import React from "react";
import SettingsPermission from "./views/SettingsPermissionPage";
import { SettingsPermissionContextProvider } from "./SettingsPermissionView";
import SettingsPermissionContent from "../../constants/contentFile.json";

const SettingsPermissionPage = () => {
  return (
    <SettingsPermissionContextProvider>
      <SettingsPermission textContent={SettingsPermissionContent.settings} />
    </SettingsPermissionContextProvider>
  );
};

export default SettingsPermissionPage;
